import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { publicData }from './publicData/index'
import echarts from 'echarts'
import { API } from "./request/api"
import components from './publicData/components'

import { fuwuData }from './publicData/fuwuData'
import 'font-awesome/css/font-awesome.css'
import { mapState, mapMutations } from 'vuex'
import TOOL from '@/library/TOOL'

Vue.use(components)
Vue.config.productionTip = false
Vue.use(ElementUI, { size:'small' })
Vue.prototype.$public = publicData
Vue.prototype.echarts = echarts
Vue.prototype.$api = API
Vue.prototype.$fuwuData = fuwuData
Vue.prototype.$t = TOOL

// 全局混入
// import mixin_base from '@/Mixins/mixin_base'
// Vue.mixin(mixin_base)
Vue.mixin({
  computed: {
    ...mapState(['puUrl_x', 'areaArrs_x', 'areaNames_x', 'areaIds_x', 'dis_x', 'pageAreaId_x', 'defaultLogo_x']),
    userInfo() { return JSON.parse(localStorage.getItem('loginData')) }
  },
  filters: {
    tofixed: val => '$'+Number(val).toFixed(2),
    toimg: imgId => {
      if (imgId && imgId.includes('http')) {
        return imgId
      } else if (imgId) {
        return store.state.puUrl_x + '/' + imgId
      } else {
        return store.state.defaultLogo_x
      }
    },
    toimgs: imgIds => {
      let newArr = []
      imgIds.forEach(x => {
        if (x && x.includes('http')) {
          newArr.push(x)
        } else if (x) {
          newArr.push(store.state.puUrl_x + '/' + x)
        } else {
          newArr.push(store.state.defaultLogo_x)
        }
      })
      return newArr
    }
  },
  methods: {
    // 请求返回的状态值处理
    _status_handler(status, cb) {
      switch (status) {
        case 1: this.$message.error('用户已被冻结'); break;
        case 2: this.$message.error('用户不存在'); break;
        case 3: this.$message.error('用户名或者密码错误'); break;
        case 4: this.$message.error('用户未登录');this.$router.push('login'); break;
        case 5: this.$message.error('名称已存在'); break;
        case 6: this.$message.error('不是管理员'); break;
        case 7: this.$message.error('系统错误'); break;
        case 8: this.$message.error('名称已存在'); break;
        case 9: this.$message.error('分站管理员已经存在'); break;
        case 10: this.$message.error('权限不够'); break;
        case 11: this.$message.error('导入文件错误'); break;
        case 12: this.$message.error('模板已过期'); break;
        case 13: this.$message.error('该地区数据不为空'); break;
        case 14: this.$message.error('招聘人数不能小于已招聘人数'); break;
        case 15: this.$message.error('账号没有设置所属地区'); break;
        case 16: this.$message.error('数据错误'); break;
        case 17: this.$message.error('验证码已过期'); break;
        case 18: this.$message.error('验证码错误'); break;
        case 19: this.$message.error('对象已存在'); break;
        case 20: this.$message.error('已达最大下载次数'); break;
        case 21: this.$message.error('该用户未上传简历'); break;
        case 22: this.$message.error('收藏已经存在'); break;
        case 23: this.$message.error('企业已存在'); break;
        case 24: this.$message.error('不是工作人员账号'); break;
        case 25: this.$message.error('不是企业账号'); break;
        case 26: this.$message.error('电话号码不存在'); break;
        case 27: this.$message.error('地址不存在'); break;
        case 28: this.$message.error('公司名称为空'); break;
        case 29: this.$message.error('公司联系电话为空'); break;
        case 30: this.$message.error('请购买短信条件'); break;
        case 31: this.$message.error('请求超时'); break;
        case 32: this.$message.error('地区错误'); break;
        case 33: this.$message.error('电子签名不存在'); break;
        case 34: this.$message.error('账号身份证号码为空'); break;
        case 35: this.$message.error('个人账号所在的公司为空'); break;
        case 36: this.$message.error('企业没有配置工资的日期字段'); break;
        case 37: this.$message.error('企业没有配置身份证字段'); break;
        case 38: this.$message.error('没有发现企业的工资配置'); break;
        case 39: this.$message.error('评论已经存在'); break;
        case 40: this.$message.error('导出数据量过大，请重新设置查询条件'); break;
        
        case 100: this.$message.error('参数不完整'); break;
        case 0: cb ? cb() : console.log('no callback running')
      }
    },
    _status(res, cb) {
      switch (res.status) {
        case 4: this.$message.error('用户未登录');this.$router.push('login'); break;
        case 100: this.$message.error('参数不完整'); break;
        case 0: cb ? cb() : console.log('no callback running')
        default: this.$message.error(res.msg); break;
      }
    },
    // 图片url处理
    _img_handler(imgId) {
      if (imgId) {
        return this.puUrl_x + '/' + imgId
      } else {
        return this.defaultLogo_x
      }
    },
    _preview_handler(img, imgs) { // 轮播预览图片
			let index = imgs.indexOf(img)
			let frontArr = imgs.slice(0, index)
			let behindArr = imgs.slice(index, imgs.length)
      let list = behindArr.concat(frontArr)
			return list.map(x => this._img_handler(x))
    },
    scrollToTop(height = 0) {
      let el = document.documentElement
      // console.log(el.scrollTop)
      let step = 0
      let interval = setInterval(() => {
        if (el.scrollTop <= height) {
          clearInterval(interval)
          return
        }
        step += 10
        el.scrollTop -= step
      }, 20)
    },
    //存入点击的菜单项
    clickMenu(route) {
      // 为打开的tap数组，默认有index，点击之后再存入点击的菜单项
      let openedTab = this.$store.state.openedTab
      // index 为当前点击的列表项在openedTab中的index，若不存在则为-1
      let index = openedTab.indexOf(route)
      if (index === -1) {
        // 该标签当前没有打开
        // 将route加入到已打开标签页state.openedTab数组中
        this.$store.commit('addTab', route)
      } else {
        // 该标签是已经打开过的，需要激活此标签页
        this.$store.commit('changeTab', route)
      }
    },
  },
})

// router.beforeEach((to, from, next) => {
//   // if() {
//       console.log(to,from)
//       next()
//   // }
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
